import React from "react";
import { Avatar } from "@fluentui/react-components";
import { mapPresenceToStatus } from "@/common/mappers/presenceMapper";
import { AvatarViewStyleProps } from "./types";
import { translateActivity } from "@/common/helpers/presenceHelper";
import { useIntl } from "react-intl";
import { useLazyUserPhoto } from "@/hooks/userPhoto/useLazyUserPhoto";

export const AvatarView = (props: AvatarViewStyleProps) => {
	const intl = useIntl();
	const agentState = props.agentState;
	const status = mapPresenceToStatus(props.agentState.availability);

	const { ref, image } = useLazyUserPhoto(props.photoId, !!props.photoId);

	return (
		<Avatar
			ref={ref as React.Ref<HTMLElement>}
			name={agentState.fullName}
			image={image}
			badge={{
				status: status,
				title: translateActivity(agentState.activity, intl),
			}}
			size={props.size ?? 48}
			color="beige"
			className={props.className ?? ""}
		/>
	);
};
